<!-- <canvas 
    baseChart 
    [colors]="colors" 
    [datasets]="dataSets" 
    [labels]="labels"
    [chartType]="type">
</canvas> -->
<div [class.chart-container]="isInDashboard">
    <canvas #chart id="chart"></canvas>
</div>